import { CalendarType } from '@lmt/shared-types';
import { MiniCalendarInternal } from '@lmt/unicorn-shared/app/components/calendar/mini-calendar/MiniCalendar';
import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import { useUniSelector } from '@lmt/unicorn-shared/app/store/types';
import React, { FC, MouseEventHandler, useMemo } from 'react';
import { addDays, addMonths } from 'date-fns';
import styles from '@lmt/unicorn-shared/src/app/components/absences/FewMonthMiniCalendar.module.scss';
import { useEventCallback } from '@mui/material';

interface Props {
  startDate: Date;
  monthCount: number;
  absences: {
    holidays: number[];
    resources: number[];
  };
  handleMouseEnter: (target: HTMLElement, date: Date | null) => void;
  // events for day cells
  onMouseOver?: MouseEventHandler<HTMLElement>;
  onMouseLeave?: MouseEventHandler<HTMLElement>;
}

const today = new Date();

export const FewMonthMiniCalendar: FC<Props> = React.memo((props) => {
  const { startDate, monthCount, absences, handleMouseEnter } = props;
  const forms = useGlobalForms();
  const claims = useClaims();

  const monthDates = useMemo(() => {
    const dates = [props.startDate];
    for (let i = 1; i < monthCount; i++) {
      dates.push(addMonths(startDate, i));
    }
    return dates;
  }, [startDate, monthCount]);
  const onDayDoubleClick = useEventCallback((date: Date) => {
    if (!claims.permissions.manageAbsences) {
      return;
    }
    forms.openAbsenceCreating({ start: date, end: addDays(date, 1) });
  });

  return (
    <div className={styles.calendarRow}>
      {monthDates.map((date, index) => (
        <MiniCalendarInternal
          key={index}
          currentMonthDate={date}
          selectedDate={today}
          mainCalendarType={CalendarType.Day}
          hideMonthArrows={true}
          headerDateFormat={'LLLL'}
          disableMonthPicker={true}
          isShowingAbsences={true}
          absences={absences}
          handleMouseEnter={handleMouseEnter}
          onMouseOver={props.onMouseOver}
          onMouseLeave={props.onMouseLeave}
          onDayCellDoubleClick={onDayDoubleClick}
        />
      ))}
    </div>
  );
});
